import { render } from "./BoxShiftSlotWithInputs.vue?vue&type=template&id=8cc81f2c&scoped=true"
import script from "./BoxShiftSlotWithInputs.vue?vue&type=script&lang=js"
export * from "./BoxShiftSlotWithInputs.vue?vue&type=script&lang=js"

import "./BoxShiftSlotWithInputs.vue?vue&type=style&index=0&id=8cc81f2c&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc81f2c"]])

export default __exports__